module.exports = __webpack_public_path__ + "static/media/grab_alc_leo_620_12.661cd65e.jpg";